import ko from 'knockout';
import _ from 'underscore';
import pageContext from '@bingads-webui-static-legacy/page-context';
import config from '@bingads-webui-component-legacy/config/index';
import state from '@bingads-webui-component-legacy/state/index';
import types from '@bingads-webui-campaign-legacy/bidding-strategy/bidding-strategy-type';

export default class ViewModel {
  constructor({
    model = {},
    scenarioToSectionsMap = {},
    scenario = 'creation-workflow',
    editModel = false,
    collapseAdvancedSettings = false,
    campaignType = 'search',
    isFinalURLSuffixEnabled,
    isMSStoreAdsGAWorkflow,
    activityLogger,
  } = {}) {

    this.model = model;
    this.campaignType = campaignType;
    this.isNewUI = config.get('IsNewUI');
    this.isAdvancedSettingsExpanded = ko.observable(editModel && !collapseAdvancedSettings);
    this.isExclusionsExpanded = ko.observable(this.isNewUI && editModel && !collapseAdvancedSettings);
    this.isFinalURLSuffixEnabled = ko.observable(isFinalURLSuffixEnabled);
    this.biddingScheme = ko.observable(_.result(_.result(this.model, 'BiddingScheme'), 'Type'));
    this.activityLogger = activityLogger;

    this.shouldShowSection = (sectionName) => {
      return _.contains(scenarioToSectionsMap[scenario], sectionName);
    };

    let allSections = _.uniq(_.flatten(_.values(scenarioToSectionsMap)));

    _.each(allSections, (sectionName) => {
      this[`show${sectionName}`] = ko.observable(this.shouldShowSection(sectionName));
      this[`infoText${sectionName}`] = ko.observable();
    }, this);
    this.infoTextDemographicTargets = ko.observable();

    //overrides
    this.showUrlOptions(this.showUrlOptions() &&
      (campaignType !== 'shopping' || this.isUpgradedUrlsForBscSettingsEnabled(campaignType)) && !isMSStoreAdsGAWorkflow);

    this.showNativeAds(this.showNativeAds() &&
      _.result(config.get('Permissions'), 'IsNativeAdsAllowed') &&
      !_.result(config.get('Permissions'), 'IsEnabledForAutoBiddingForAudienceNetwork') &&
      (campaignType === 'search' || campaignType === 'shopping'));

    this.showMultimediaAds = ko.observable(pageContext.Permissions.IsMultiMediaAdsEnabled && campaignType === 'search' &&
      (!pageContext.Permissions.IsDomesticSimplifiedChineseEnabled || (pageContext.Permissions.IsDomesticSimplifiedChineseEnabled && pageContext.Permissions.dynamic.MMAForCN)));

    this.showAdSchedule(this.showAdSchedule());
    this.showDemographicTargets = ko.computed(() => {
      if (campaignType === 'audience') {
        return false;
      } else {
        return this.showAgeTargets() || this.showGenderTargets();
      }
    }, this);
    this.showTargetsSection = ko.computed(() => {
      return this.showAdSchedule() || this.showDeviceTargets() || this.showDemographicTargets();
    }, this);
    this.showOtherSettingsSection = ko.computed(() => {
      return this.showNativeAds() || this.showAdRotation() || this.showAdDistribution() || this.showMultimediaAds();
    }, this);
    this.showExclusions = ko.computed(() => {
      return this.showSiteExclusion() || this.showIPExclusion();
    }, this);

    this.biddingScheme.subscribe((value) => {
      this.showSearchCampaignPredictiveMatching(this.shouldShowSearchCampaignPredictiveMatching(value));
    }, this);

    this.showVanityUrlSettings(this.showVanityUrlSettings() &&
      pageContext.Permissions.IsVanityUrlEnabled && pageContext.Permissions.dynamic.VanityUrlWebsiteDescription &&
      campaignType === 'search');
    if (this.showVanityUrlSettings()) {
      this.vanityUrlSettings = ko.observable(_.find(this.model.CampaignSettings, (setting) => setting['@odata.type'] === '#Model.VanityPharmaSetting') || {
        DisplayUrlMode: 'ManufacturerWebsiteUrl',
        WebsiteDescription: 'Unspecified',
      });
    }

    this.showSearchCampaignPredictiveMatching = ko.observable(this.shouldShowSearchCampaignPredictiveMatching(this.biddingScheme()));
    const predictiveTargetingSettings = _.find(model.CampaignSettings, (setting) => setting['@odata.type'] === '#Model.PredictiveTargetingSetting') || {};

    this.predictiveMatchingChecked = ko.observable(predictiveTargetingSettings.PredictiveTargetingEnabled || false);
    this.predictiveMatchingChecked.subscribe((value) => {
      if (this.activityLogger) {
        this.activityLogger.signal(`set predictive matching: ${value}`, 'advanced-settings');
      }
    });
  }

  shouldShowSearchCampaignPredictiveMatching(biddingSchema) {
    const isSearchCampaign = this.campaignType === 'search';
    const isPredictiveMatchingEnabled = _.result(pageContext && pageContext.Permissions && pageContext.Permissions.dynamic, 'PredictiveMatching', false);

    const isBidstrategySupport = [
      types.targetCpa,
      types.targetRoas,
      types.maximizeConversions,
    ].includes(biddingSchema);

    return this.showPredictiveMatching() && isSearchCampaign && isPredictiveMatchingEnabled && isBidstrategySupport;
  }

  isUpgradedUrlsForBscSettingsEnabled(campaignType) {
    //test usage - enable native ads for specific bing shopping campaign
    return campaignType === 'shopping' && (
      (state.get('customer_id') === '11270641' && state.get('account_id') === '3096017') ||
      _.result(config.get('Permissions'), 'IsUpgradedUrlsForBscSettingsEnabled'));
  }
}
